export default __webpack_public_path__ + "static/media/Clear.ce890bce.png";